<template>
  <el-dialog
    v-if="model"
    :title="
      (model.id > 0 ? '编辑' : '发布') +
      (model.category == 1 ? '求购' : '回收') +
      '请求'
    "
    :visible.sync="visible"
    width="500px"
    @close="$emit('update:show', false)"
    :close-on-click-modal="false"
  >
    <el-form
      v-if="model"
      ref="form"
      label-width="110px"
      :model="model"
      :rules="formRules"
    >
      <el-form-item label="最终需求客户" prop="customer_id">
        <customer-select
          class="long"
          :val="model.customer_id"
          :add="true"
          @change="model.customer_id = $event"
        ></customer-select>
      </el-form-item>
      <el-form-item label="设备描述" prop="material_desc">
        <el-input
          placeholder="请输入请求设备描述"
          v-model="model.material_desc"
        >
        </el-input>
      </el-form-item>
      <el-form-item label="设备号" prop="device_number">
        <el-input placeholder="请输入设备号" v-model="model.device_number">
        </el-input>
      </el-form-item>
      <el-form-item label="数量" prop="quantity">
        <el-input placeholder="" v-model="model.quantity"> </el-input>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input
          type="textarea"
          :rows="2"
          placeholder=""
          v-model="model.remark"
        >
        </el-input>
      </el-form-item>
      <el-form-item label="联系人" prop="contact_name">
        <el-input placeholder="" v-model="model.contact_name"> </el-input>
      </el-form-item>
      <el-form-item label="联系电话" prop="contact_mobile">
        <el-input placeholder="" v-model="model.contact_mobile"> </el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button
        size="small"
        type="primary"
        :loading="submiting"
        @click="submitForm"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import CustomerSelect from '@/components/select/customer_select'
import {
  createDeviceQuest,
  createUsedDevice,
  updatedeviceQuest,
  updateUsedDevice,
} from '../../service/getData'

export default {
  components: {
    CustomerSelect,
  },
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
  },
  data() {
    return {
      visible: this.show,
      formRules: {
        material_desc: [
          { required: true, message: '请输入请求设备描述', trigger: 'blur' },
        ],
        customer_id: [
          { required: true, message: '请选择客户', trigger: 'change' },
        ],
      },
      submiting: false,
    }
  },
  created() {},
  methods: {
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.submiting = true
          this.model.quantity = parseInt(this.model.quantity) || 1
          if (this.model.id > 0) {
            let res = await updatedeviceQuest(this.model)
            if (res.code == 0) {
              this.$emit('updated', res.data)
            }
          } else {
            let res = await createDeviceQuest(this.model)
            if (res.code == 0) {
              this.$emit('created', res.data)
            }
          }
          this.submiting = false
          this.visible = false
        } else {
          this.submiting = false
        }
      })
    },
  },
}
</script>